import { useContext } from 'react';

import NotificationContext from './notification.context';

function useNotification() {
  const context = useContext(NotificationContext);

  if (!context) {
    throw new Error('useNotification must be used within NotificationContext');
  }

  return context;
}

export default useNotification;